import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=6c62998c&scoped=true&"
import script from "./ApproveModal.vue?vue&type=script&lang=js&"
export * from "./ApproveModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveModal.vue?vue&type=style&index=0&id=6c62998c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c62998c",
  null
  
)

export default component.exports